import { Descriptions } from "antd";
import styled from "styled-components";
import { theme } from "../../../../theme";

const CustomDescription = styled(Descriptions)`
  &.ant-descriptions {
    & .ant-descriptions-view {
      border-radius: 8px;
      & .ant-descriptions-item-label {
        background: #f3f5fa;
        ${theme.typo.heading.b14};
      }
      & .ant-descriptions-item-content {
        min-width: calc(50% - 200px);
      }
    }
  }
`;

const DescriptionTitle = styled.div`
  ${theme.typo.heading.b16};
  color: ${theme.colors.gray1};
`;

export { CustomDescription, DescriptionTitle };
